export default __webpack_public_path__ + "static/media/EqStocks.7b4f6d85.svg";